import { get } from '@_shared/config';

import { notificationModel } from '../model';

export async function getNotificationList() {
	return get<notificationModel.TNotificationsResponse>('/user/web-notification');
}

export async function reminder() {
	return get<notificationModel.TNotificationReminder>('/user/web-notification/reminder');
}
